/* eslint-disable no-unused-vars */
import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import _ from 'lodash'
import {
  firebaseConnect,
  isLoaded,
  isEmpty
} from 'react-redux-firebase'
import {  Container, Table, Rating, Header, Icon, Pagination, Statistic, Grid, Button, Loader, Feed, Popup, List, Card, Segment, Sidebar, Menu, Label } from 'semantic-ui-react'
// import { withProps } from "recompose"
import MapGL, { Marker, SVGOverlay, CanvasOverlay, LinearInterpolator, FlyToInterpolator } from 'react-map-gl';
import moment from 'moment'
import { MAPBOX_TOKEN } from '../../../../config/tokens'
import { isAdmin } from '../../../../utils/admin'

// maybe i need this?
import {scaleOrdinal} from 'd3-scale';
import {schemeCategory10} from 'd3-scale-chromatic';
import {rgb} from 'd3-color';

// import dude, { bro } from '../../../utils/dude'

import DashboardMap from './DashboardMap'

const windowAlert = window.alert;


// function round(x, n) {
//   const tenN = Math.pow(10, n);
//   return Math.round(x * tenN) / tenN;
// }

// function getRGBA(color) {
//   const {r,g,b,a} = color
//
//   const rr = r > 0 ?  Math.floor(255*r) : 0
//   const gg = g > 0 ?  Math.floor(255*g) : 0
//   const bb = b > 0 ?  Math.floor(255*b) : 0
//
//   if(rr > 255 || gg > 255 || bb > 255)
//     return `rgba(${r}, ${g}, ${b}, ${a})`; // this is an error
//
//   return `rgba(${rr}, ${gg}, ${bb}, ${a})`;
// }

// ----------------------------------------------------------

// BrowseSidebar
const BrowseSidebar = ({mode, sessions, activeSession, relatedSessions, onSessionClick}) => {

  // const { loading,  } = this.state

  // if(mode === 'browse') {
    return (
    <Sidebar as={Menu} direction='left' visible={true} vertical width='thin' inverted>
      <Menu.Item>
      <Menu.Header as='h1'> Recent Sessions</Menu.Header>
      <Menu.Menu>
        {_.map(sessions, (session,key) =>
          <Menu.Item name={''+session._key} active={activeSession._key === session._key} as='a' key={key} onClick={ ()=> onSessionClick(session) }>
            {session.username || 'null'}
          </Menu.Item>
        )}
        </Menu.Menu>
        </Menu.Item>
      </Sidebar>
        )
  // }


}
// STATS
const ZoomButtons = ({mode, zoomIn, zoomOut}) => {


  // if(mode === 'discover')
    return (
      <div style={{position: 'absolute', bottom: 50, right: 50}}>
    <Button circular basic icon='zoom in' color='black' onClick={zoomIn} />
    <Button circular basic color='black' icon='zoom out' onClick={zoomOut} />
  </div>
    )
  // else
  // return null
}


const ActiveUser = ({activeUser, activeSession, onSessionClick}) => {

  if(!activeUser) { return null; }



  return (

    <Menu vertical style={{position: 'absolute', top: 0, right: 50, maxWidth: 200, maxHeight: '80%',overflow: 'auto'}}>
    <Menu.Header as='h3'>{activeUser.username}</Menu.Header>

    <Menu.Menu>
    {_.map(activeUser.sessions, (session,key) =>
      <Menu.Item name={''+session._key} active={activeSession._key === session._key} as='a' key={key} onClick={ ()=> onSessionClick(session) }>
        <p style={{color: 'black'}}><b>{moment(session.createdAt).fromNow()}</b></p>
        {session.locale}

      </Menu.Item>
    )}
    </Menu.Menu>
    </Menu>


  )


}

// ----------------------------------------------------------

class Map extends Component {

  state = {
    // shareWith: '',
    // loading: true,
    // dataLoaded: false,
    // visibleDrawings: [],
    // viewport: {
    //   bearing: 0,
    //   // pitch: 50,
    //   pitch: 0,
    //   width: 700,
    //   height: 600,
    // },
    // settings: {
    //   dragPan: true,
    //   dragRotate: true,
    //   scrollZoom: true,
    //   touchZoom: true,
    //   touchRotate: true,
    //   keyboard: true,
    //   doubleClickZoom: true,
    //   minZoom: 0,
    //   maxZoom: 20,
    //   minPitch: 0,
    //   maxPitch: 85
    // },
    drawingLocations: [],
    // userLocations: [],
    //
    loading: true,
    sessions: [],
    activeSession: {},
    activeUser: null,
    relatedSessions: [],
    // onSessionClick: (session) => { this.setState({activeSession: session}) },
    zoom: 2,
    mode: 'browse',
    fetchViewport: (viewport) => this._handleViewportChanges(viewport),
    // zoomIn:

    visibleSessionMarkers: 9,
    onSessionClick: (session,key) => {
      this.setState({
        activeSession: session,
        activeUser: {
          username: session.username,
          sessions: _.filter(this.state.sessions,s => s.username === session.username)
        },
        relatedSessions: _.filter(this.state.sessions,s => s.username === session.username)
      })
    },

  }

  componentDidMount() {
    if(this.state.loading && isLoaded(this.props.sessions))
      this._setData()
  }

  componentDidUpdate(prevProps) {
    if(this.state.loading && isLoaded(this.props.sessions))
      this._setData()
  }


    _handleViewportChanges = (viewport) => {
      console.log('viewpoer',viewport)
      this._setModeFromZoom(viewport.zoom)
      this.setState({visibleSessionMarkers: viewport.visibleSessionMarkers})
    }

    _setModeFromZoom = (zoom) => {
      const { mode } = this.state
      let newMode
      if(zoom > 12)
        newMode = 'browse'
      else
        newMode = 'Discover'

      if(mode !== newMode)
        this.setState({mode: newMode}) // based on zoom


    }

    _setData = () => {
      // console.log('SET DATA!',this.props.sessions)
      // const { sessions } = this.props
      const { loading } = this.state



      // filter out sessions without coordinates
      let filteredSessions = _.pickBy(this.props.sessions, s => s.l)
      filteredSessions = _.pickBy(filteredSessions, s => s.username)


      const sessions = _.map(filteredSessions, (session, key) => {

        const line = _.find(session.lines,'time') || {time: 0}
        return (
          {
            ...session,
            _key: key,
            createdAt: line.time * 1000,
            latitude: session.l[0],
            longitude: session.l[1],
            coordinates: [session.l[1],session.l[0]],
            otherSessionsByUser: _.filter(sessions,s => s.username === session.username), // bug
          }
        )
      })
      const orderedSessions = _.orderBy(sessions,['createdAt'],['desc'])
      // console.log('o',orderedSessions)
      this.setState({
        sessions: orderedSessions,
        activeSession: orderedSessions[0],
        relatedSessions: _.filter(orderedSessions,s => s.username === orderedSessions[0].username),
        loading: false,
        activeUser: {
          username: orderedSessions[0].username,
          sessions: _.filter(orderedSessions,s => s.username === orderedSessions[0].username)
        },
      })
      // DATA LOADED!


    }

    // _onSessionClick = (session,key) => {
    //   this.setState({
    //     activeSession: session,
    //     relatedSessions: _.filter(this.state.sessions,s => s.username === session.username)
    //   })
    // }

    // begin map functions

    _toggleZoom = () => {
      this.setState({zoom: 14})
    }

    render() {
      if(!isAdmin(this.props.auth)) { return null }
      const { loading, sessions, activeSession, relatedSessions, mode, } = this.state
      if(loading) { return <Loader active /> }

      // console.log('STATE',this.state)
      return (
        <div>





          <Sidebar.Pusher>

              <DashboardMap {...this.state} />

          </Sidebar.Pusher>




          <BrowseSidebar {...this.state} />

          <ActiveUser {...this.state} />

      </div>
      )

    }

    renderr() {
    //   if(!isAdmin(this.props.auth)) { return null }
    //   const { loading, sessions, activeSession, relatedSessions, zoom } = this.state
    //   if(loading) { return <Loader active /> }
    //
    //   // console.log('STATE',this.state)
    //   return (
    //     <div>
    //
    //       <Sidebar as={Menu} direction='left' visible={true} vertical width='wide'>
    //
    //
    //
    //       <Menu.Item>
    //       <Menu.Header as='h1'>Recent Sessions</Menu.Header>
    //       <Feed >
    //       {_.map(sessions, (session,key) =>
    //         <Feed.Event>
    //         <Feed.Label>
    //                 <Icon name='pencil' size='tiny'/>
    //               </Feed.Label>
    //     <Feed.Content>
    //     <Feed.Date>{moment(session.createdAt).fromNow()}</Feed.Date>
    //       <Feed.Summary>
    //         <Feed.User>{session.username}</Feed.User> drew some lines
    //
    //       </Feed.Summary>
    //
    //     </Feed.Content>
    //   </Feed.Event>
    //       )}
    //
    //
    //
    //           </Feed>
    //
    //       <Menu.Menu>
    //
    //         {_.map(sessions, (session,key) =>
    //           <Menu.Item name={session._key} active={activeSession._key === session._key} as='a' key={key} onClick={ ()=> this._onSessionClick(session) }>
    //             {session.username || 'null'}
    //
    //
    //
    //
    //           </Menu.Item>
    //         )}
    //         </Menu.Menu>
    //         </Menu.Item>
    //       </Sidebar>
    //
    //       <Sidebar as={Menu} animation='overlay' direction='right' vertical visible={true} >
    //         <Menu.Item as='h1' header>{activeSession.username}</Menu.Item>
    //
    //
    //
    //         <div className='session-cards'>
    //
    //         {_.map(relatedSessions, (session,key) => {
    //           let active = activeSession._key === session._key
    //
    //           return (<Card key={key} onClick={ ()=> this._onSessionClick(session)} color={active ? 'green' : 'black'}>
    //   <Card.Content>
    //     <Card.Header></Card.Header>
    //     <Card.Meta>{moment(session.createdAt).fromNow()}</Card.Meta>
    //     <Card.Description>{session.locale}</Card.Description>
    //   </Card.Content>
    // </Card>)
    //         }
    //
    //         )}
    //
    //         </div>
    //
    //       </Sidebar>
    //
    //       <Sidebar.Pusher>
    //
    //           <DashboardMap {...this.state} />
    //
    //       </Sidebar.Pusher>
    //
    //   </div>
    //   )

    }
}


// export default enhance(ContentDetails)

export default compose(
  firebaseConnect(props=> {
    // console.log('props in connect',props)

    return [
      // 'geoFire',
      'users',
      { path: '/geoFire', queryParams: [ 'limitToLast=200' ] }
    ]
  }),
  connect((state) => ({
    // sessions: _.map(state.firebase.data.geoFire, (session, key) => ({...session, _key: key}) ),
    sessions: state.firebase.data.geoFire,
    // profile: state.firebase.profile // load profile
    auth: state.firebase.auth,
  }))
)(Map)



// WEBPACK FOOTER //
// ./src/components/pages/Dashboard/v1/Dashboard.js